import { Button, type IconName, type Intent } from "@blueprintjs/core";
import { useItemSelectState } from "./item-select-context";
import {
  getDisplayForDocumentItem,
  type ItemSelectQuery,
} from "./item-select-utils";

export type ItemSelectButtonProps = {
  className?: string;
  icon?: IconName;
  intent?: Intent;
  noSelectionText?: string;
};

export function ItemSelectButton<Q extends ItemSelectQuery>({
  className,
  icon,
  intent,
  noSelectionText,
}: ItemSelectButtonProps) {
  const { activeItemId, disabled, items } = useItemSelectState();

  return (
    <Button
      alignText="left"
      className={className}
      disabled={disabled}
      fill
      icon={icon}
      intent={intent}
      minimal
      outlined
      rightIcon="caret-down"
      text={
        activeItemId
          ? getDisplayForDocumentItem<Q>(
              items?.find((item) => item.id === activeItemId),
            )
          : (noSelectionText ?? "Select an Item")
      }
    />
  );
}
